import customFetch from "../helpers/customFetch";
import { API_URL, getConfigExactian } from "../helpers/helpers";

export const getPermanenceReportService = async (values) => {
    try {
        const configs = getConfigExactian('POST', values)
        const response = await customFetch(`${API_URL}reports/permanenceReport`, configs);
        if (!response.ok) {
            return {
                ok: false,
                data: response
            }
        } else {
            const resData = await response.json();
            return {
                ok: true,
                data: resData
            }
        }
    } catch (e) {
        return console.log(e);
    }
}

export const getPermanenceTotalsReportService = async (values) => {
    try {
        const configs = getConfigExactian('POST', values)
        const response = await customFetch(`${API_URL}reports/permanenceTotals`, configs);
        if (!response.ok) {
            return {
                ok: false,
                data: response
            }
        } else {
            const resData = await response.json();
            return {
                ok: true,
                data: resData
            }
        }
    } catch (e) {
        return console.log(e);
    }
}

export const downloadPermanenceReportService = async (values) => {
    try {
        const configs = getConfigExactian('POST', values)
        const response = await customFetch(`${API_URL}reports/permanenceReportDownload`, configs);
        const resData = await response.blob();
        if (!response.ok) {
            return {
                ok: false,
                data: response,
            };
        } else {
            return {
                ok: true,
                data: resData,
            };
        }
    } catch (e) {
        console.log(e);
    }
};
